import { render, staticRenderFns } from "./usergroup-install-orders.vue?vue&type=template&id=52ab188c&scoped=true"
import script from "./usergroup-install-orders.vue?vue&type=script&lang=js"
export * from "./usergroup-install-orders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52ab188c",
  null
  
)

export default component.exports